// src/components/MuiMonthPicker.jsx (or a similar name)

import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

/**
 * An isolated MUI Month Picker that works with a "YYYY-MM" string state.
 */
export function MonthPicker({ value, onChange, hideIcon = false }) {
    const handleMonthChange = (newValue) => {
        if (newValue) {
            onChange(newValue.format('YYYY-MM'));
        } else {
            onChange('');
        }
    };

    const dayjsValue = value ? dayjs(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                views={['year', 'month']}
                openTo="month"
                format="MMMM YYYY"
                value={dayjsValue}
                onChange={handleMonthChange}
                slots={{
                    openPickerIcon: hideIcon ? () => null : undefined,
                }}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: "outlined",
                        InputProps: hideIcon
                            ? { endAdornment: null }
                            : undefined,
                    },
                }}
            />
        </LocalizationProvider>
    );
}
